<template>
  <div class="popup record-popup" style="z-index: 20; max-width: 420px">
    <div class="modal-overlay" style="opacity: 0.16" />
    <div class="modal-content">
      <h2 v-html="$t('loading')" />
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingPopup",
}
</script>

<style scoped lang="scss">

</style>
